import hress3uLabels from 'assets/labels/hress3u'
import faker from 'faker'
import moment from 'moment'
import labels from 'src/../config/label.js'

export const mocker = {
  labels () {
    return {
      labels: hress3uLabels
    }
  },
  index () {
    let mockRows = []
    let staappr = ''
    const mockStaappr = [ 'P', 'Y', 'N', 'A', 'C' ]
    const mockStatus = {
      'P': 'รอพิจารณา',
      'Y': 'อนุมัติ',
      'N': 'ไม่อนุมัติ',
      'A': 'ระหว่างอนุมัติ',
      'C': 'ยกเลิก'
    }
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      staappr = mockStaappr[Math.floor(Math.random() * 5)]
      mockRows.push({
        id: i,
        codempid: faker.lorem.word(),
        desc_codempid: faker.name.findName(),
        dtereq: moment().format('DD/MM/YYYY'),
        numseq: faker.random.number().toString().substr(0, 1),
        status: mockStatus[staappr],
        desc_codappr: faker.name.findName(),
        dteappr: moment().format('DD/MM/YYYY'),
        remark: 'Test System',
        desc_codempap: faker.name.findName(),
        staappr: '',
        approvno: faker.random.number().toString().substr(0, 1),
        chk_appr: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      codempid: faker.lorem.word(),
      desc_codempid: faker.name.findName(),
      codpfinf: faker.lorem.word(),
      desc_codpfinf: faker.random.words(),
      nummember: faker.lorem.word(),
      dteeffec: moment().format('DD/MM/YYYY'),
      flgemp: '',
      dtereti: moment().format('DD/MM/YYYY'),
      remark: 'Test Hress3u',
      ratereta: faker.random.number().toString().substr(0, 2),
      dtechg: moment().format('DD/MM/YYYY'),
      dteeffec2: moment().format('DD/MM/YYYY'),
      codpolicy: faker.lorem.word(),
      desc_codpolicy: faker.random.words(),
      qtycompst: ''
    }
    let mockTab1Rows = []
    const mockTab1Total = 5
    for (var i = 1; i <= mockTab1Total; i++) {
      mockTab1Rows.push({
        id: i,
        codpolicy: faker.lorem.word(),
        desc_codpolicy: faker.random.words(),
        qtycompst: '100.00'
      })
    }
    let mockTab2Rows = []
    const mockTab2Total = 5
    for (var a = 1; a <= mockTab2Total; a++) {
      mockTab2Rows.push({
        id: a,
        numseq: faker.random.number().toString().substr(0, 1),
        nampfic: faker.name.findName(),
        adrpfic: faker.address.streetAddress(),
        desrel: 'Test',
        ratepf: faker.random.number().toString().substr(0, 2)
      })
    }

    return {
      tab1: {
        detail: mockTab1,
        table: {
          total: mockTab1Total,
          rows: mockTab1Rows
        }
      },
      tab2: {
        table: {
          total: mockTab2Total,
          rows: mockTab2Rows
        }
      }
    }
  },
  detailSubmit () {
    let mockTab1 = {
      staappr: '',
      flgStaappr: '',
      approvno: '1',
      chk_appr: '',
      numseq: '1',
      dtereq: moment().format('DD/MM/YYYY'),
      codempid: faker.lorem.word(),
      desc_codempid: faker.lorem.words(),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      dteeffec: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
    return {
      tab1: mockTab1
    }
  },
  approve () {
    return {
      codempid: faker.lorem.word() + ' - ',
      desc_codempid: faker.name.findName(),
      approvno: faker.random.number().toString().substr(0, 1),
      codappr: faker.lorem.word(),
      desc_codappr: faker.lorem.word(),
      dteappr: moment().format('DD/MM/YYYY'),
      amtappr: faker.commerce.price(),
      typepay: '1',
      dtepay: moment().format('DD/MM/YYYY'),
      numperiod: faker.random.number().toString().substr(0, 1),
      dtemthpay: moment().format('DD/MM/YYYY'),
      dteyrepay: moment().format('DD/MM/YYYY'),
      codpay: '',
      staappr: '',
      status: faker.lorem.words(),
      remark: faker.lorem.words()
    }
  },
  sendApprove () {
    return labels.mockPostMessage
  }
}



// WEBPACK FOOTER //
// ./src/api/hress3u/mocker.js